// @flow
import React from 'react';
import { Box, Flex, Divider, Text, Icon } from '@locus-taxy/neo-ui';
import { withRouter } from 'common/components/core/router';
import { useTranslation } from 'react-i18next';
import UserProfileImage from '../UserProfileImage';
import MapButton from '../MapButton';
import EventUtils from 'common/utils/EventUtils';

import theme from './Contact.scss';

export type ContactType = {
    userId: string,
    photoUrl: string,
    riderId: string,
    name: string
};

type Props = { onContactClick: (user: ContactType) => void } & ContactType;

const Contact = ({
    name,
    riderId,
    onContactClick,
    userId,
    photoUrl
}: Props): React$Element<any> => {
    const { t } = useTranslation('liveView');

    return (
        <Box px={4} sx={{ cursor: 'pointer' }} className={theme.contactCard}>
            <Flex
                my={2}
                pr={2}
                alignItems="center"
                onClick={() => {
                    onContactClick({
                        userId,
                        name,
                        photoUrl,
                        riderId
                    });
                }}
            >
                <UserProfileImage url={photoUrl} isOnline={false} />
                <Text
                    fontSize={2}
                    fontWeight={600}
                    sx={{ flexGrow: 1 }}
                    mx={4}
                    truncated
                >
                    {name || t('riderManagerChat.locusUser')}
                </Text>
                {name && (
                    <Flex
                        alignItems="center"
                        onClick={EventUtils.stopPropagation}
                        className={theme.singleRiderLinkBtn}
                    >
                        <MapButton riderId={riderId} />
                        <Icon
                            icon="arrow_chevron_right"
                            size="small"
                            color="grey.500"
                            ml={2}
                        />
                    </Flex>
                )}
            </Flex>
            <Divider color="grey.200" />
        </Box>
    );
};

export default withRouter(Contact);
